"use client";

import { c as _c } from "react/compiler-runtime";
import ContentDisplay from "@/components/waves/drops/ContentDisplay";
import { buildProcessedContent, type ProcessedContent } from "@/components/waves/drops/media-utils";
import { getRandomColorWithSeed, getTimeAgoShort } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import type { SidebarWave } from "@/types/waves.types";
import Image from "next/image";
import Link from "next/link";
interface ExploreWaveCardProps {
  readonly wave: SidebarWave;
}
export function ExploreWaveCard(t0) {
  const $ = _c(40);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] !== wave.id || $[1] !== wave.isDirectMessage) {
    t1 = getWaveRoute({
      waveId: wave.id,
      isDirectMessage: wave.isDirectMessage,
      isApp: false
    });
    $[0] = wave.id;
    $[1] = wave.isDirectMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const waveHref = t1;
  let t2;
  if ($[3] !== wave.id) {
    t2 = getRandomColorWithSeed(wave.id);
    $[3] = wave.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const banner1 = t2;
  let t3;
  if ($[5] !== wave.name) {
    t3 = getRandomColorWithSeed(wave.name);
    $[5] = wave.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const banner2 = t3;
  let t4;
  if ($[7] !== banner1 || $[8] !== banner2 || $[9] !== wave.picture) {
    t4 = !wave.picture ? {
      background: `linear-gradient(135deg, ${banner1} 0%, ${banner2} 100%)`
    } : undefined;
    $[7] = banner1;
    $[8] = banner2;
    $[9] = wave.picture;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const imageAreaStyle = t4;
  const lastMessageTime = wave.latestDropTimestamp;
  const hasDrops = lastMessageTime !== null;
  let t5;
  if ($[11] !== wave) {
    t5 = getWavePreviewContent(wave);
    $[11] = wave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const descriptionPreview = t5;
  const t6 = `View wave ${wave.name}`;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-rounded-xl tw-border tw-border-solid tw-border-white/10" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== wave.name || $[15] !== wave.picture) {
    t8 = wave.picture && <Image src={getScaledImageUri(wave.picture, ImageScale.AUTOx450)} alt={`${wave.name} cover`} fill={true} sizes="(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 33vw" className="tw-object-cover tw-transition-transform tw-duration-700 tw-will-change-transform desktop-hover:group-hover:tw-scale-105" />;
    $[14] = wave.name;
    $[15] = wave.picture;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== imageAreaStyle || $[18] !== t8) {
    t9 = <div className="tw-relative tw-aspect-[20/9] tw-overflow-hidden" style={imageAreaStyle}>{t8}</div>;
    $[17] = imageAreaStyle;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== wave.name) {
    t10 = <span className="tw-m-0 tw-line-clamp-1 tw-break-words tw-text-sm tw-font-semibold tw-leading-tight tw-text-white tw-transition-colors group-hover:tw-text-white/80 sm:tw-text-base">{wave.name}</span>;
    $[20] = wave.name;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== descriptionPreview) {
    t11 = descriptionPreview && <MessagePreviewContent previewContent={descriptionPreview} />;
    $[22] = descriptionPreview;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== hasDrops || $[25] !== lastMessageTime || $[26] !== wave.totalDropsCount) {
    t12 = hasDrops && <div className="tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1 tw-text-[11px] tw-text-iron-500 sm:tw-text-xs"><span className="tw-relative tw-flex tw-h-2 tw-w-2"><span className="tw-absolute tw-inline-flex tw-h-full tw-w-full tw-animate-ping tw-rounded-full tw-bg-success/60" /><span className="tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-success" /></span><span className="tw-text-iron-300">{getTimeAgoShort(lastMessageTime)} ·{" "}{wave.totalDropsCount.toLocaleString()}</span>{" "}drops</div>;
    $[24] = hasDrops;
    $[25] = lastMessageTime;
    $[26] = wave.totalDropsCount;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== hasDrops) {
    t13 = !hasDrops && <div className="tw-mt-3 tw-text-[11px] tw-text-iron-500 sm:tw-text-xs">No drops yet</div>;
    $[28] = hasDrops;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13) {
    t14 = <div className="tw-px-4 tw-py-6 sm:tw-p-5">{t10}{t11}{t12}{t13}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t14 || $[36] !== t6 || $[37] !== t9 || $[38] !== waveHref) {
    t15 = <Link href={waveHref} prefetch={false} className="tw-group tw-relative tw-block tw-overflow-hidden tw-rounded-xl tw-bg-iron-950 tw-text-left tw-no-underline tw-transition-all tw-duration-300 tw-ease-out focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500/30" aria-label={t6}>{t7}{t9}{t14}</Link>;
    $[35] = t14;
    $[36] = t6;
    $[37] = t9;
    $[38] = waveHref;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}
function MessagePreviewContent(t0) {
  const $ = _c(2);
  const {
    previewContent
  } = t0;
  if (!previewContent) {
    return null;
  }
  let t1;
  if ($[0] !== previewContent) {
    t1 = <ContentDisplay content={previewContent} shouldClamp={false} className="tw-mt-1 tw-flex tw-min-w-0 tw-flex-1 tw-items-start tw-gap-1 tw-overflow-hidden tw-text-iron-500" textClassName="tw-line-clamp-2 tw-break-words tw-text-[10px] tw-font-normal tw-leading-tight sm:tw-text-xs" linkify={false} />;
    $[0] = previewContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function getWavePreviewContent(wave: SidebarWave): ProcessedContent | null {
  const combinedText = wave.descriptionDrop.contents?.trim() ?? "";
  const media = [...wave.descriptionDrop.media];
  if (!combinedText && media.length === 0) {
    return null;
  }
  return buildProcessedContent(combinedText || null, media);
}